export const DEFAULT_VIEWS = [
	{ id: "all", code: "all", flowName: "All" },
	{ id: "assignedToMe", code: "assignedToMe", flowName: "Assigned to Me" }
];

export const TASK_DEFAULT_VIEWS = [...DEFAULT_VIEWS, { id: "assignedByMe", code: "assignedByMe", flowName: "Assigned by Me" }];
